import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalService } from './media-preview-service';
import { SafeWindow } from '../../utils/safe-window';

@Component({
  standalone: false,
  selector: 'app-media-preview-modal',
  templateUrl: './media-preview-modal.component.html',
  styleUrl: './media-preview-modal.component.css',
})
export class MediaPreviewModalComponent implements AfterViewInit, OnInit {
  @Input() data: any;
  @Input() url: string | null = null;
  @Input() urlType: string | null = null;
  isVisible = false;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  scrollPosition = 0;
  windowScrollPosition = 0;
  win = SafeWindow.get();
  private destroyRef = inject(DestroyRef);

  constructor(private modalService: ModalService) {}

  ngAfterViewInit(): void {
    if (this.videoPlayer) {
      this.videoPlayer.nativeElement.addEventListener(
        'fullscreenchange',
        this.onFullscreenChange.bind(this),
      );
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.win) {
      this.windowScrollPosition =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (this.windowScrollPosition !== 0) {
        this.scrollPosition = this.windowScrollPosition;
      }
    }
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange() {
    if (document.fullscreenElement) {
      this.disableScroll();
    } else {
      this.enableScroll();
      this.preventScrollJump();
    }
  }

  private disableScroll() {
    document.body.style.overflow = 'hidden';
  }

  private enableScroll() {
    document.body.style.overflow = 'auto';
  }

  private preventScrollJump() {
    if (this.scrollPosition !== null) {
      setTimeout(() => {
        if (this.win) {
          window.scrollTo(0, this.scrollPosition);
        }
      }, 0);
    }
  }

  ngOnInit(): void {
    this.modalService.isVisible$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isVisible) => {
        this.isVisible = isVisible;
        if (this.isVisible) {
          this.disableScroll();
        }
      });

    this.modalService.modalParams$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        if (params) {
          this.url = params.url;
          this.urlType = params.urlType;
        }
      });
  }

  close() {
    this.modalService.hide();
    this.enableScroll();
  }
}
